var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "289.9px",
    height: "242.5px",
    viewBox: "0 0 289.9 242.5",
    style: {
      enableBackground: "new 0 0 289.9 242.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000134226927640304096990000009187809977734665387_);}\n\t.st2{fill:url(#SVGID_00000144326603152000246830000015135450243420469393_);}\n\t.st3{fill:url(#SVGID_00000106840812819100779730000001731131730461117360_);}\n\t.st4{fill:url(#SVGID_00000003812909884953319440000011667603099846854068_);}\n\t.st5{fill:url(#SVGID_00000020362594071598778380000013315330867593976505_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.2442,
    y1: 269.1117,
    x2: 212.3594,
    y2: 269.1117,
    gradientTransform: "matrix(1 0 0 -1 0 376.6277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002398023,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2472,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6136,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8733,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffffff"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.4,88.7c0-1.9,0.5-3.3,1.5-4.4c1-1,2.5-1.5,4.4-1.5c1.1,0,1.9,0.2,2.6,0.5c0.7,0.3,1.3,0.8,1.9,1.3 l6.5-6.6c-1.4-1.5-3-2.6-4.8-3.5c-1.8-0.8-3.9-1.3-6.4-1.3c-3.3,0-6.1,0.7-8.5,2c-2.4,1.4-4.3,3.2-5.6,5.6c-1.3,2.3-2,5-2,8.1V93 h-8.8v9.1h8.8v39.8l10.3-10.3l0.1-29.4h11.3V93H91.4L91.4,88.7L91.4,88.7z M130.4,114.8c0,2.4-0.6,4.2-1.8,5.5c-1.2,1.3-2.9,2-5,2 c-1.4,0-2.7-0.3-3.7-0.9c-1.1-0.6-1.8-1.4-2.4-2.6c-0.5-1.1-0.8-2.5-0.8-4.1V93h-10.4v22.1c0,3.3,0.7,6.2,2.2,8.7s3.5,4.5,6.1,5.9 c2.6,1.4,5.6,2.1,8.9,2.1c3.4,0,6.3-0.7,8.9-2.1c2.6-1.4,4.6-3.3,6.1-5.9c1.4-2.5,2.2-5.5,2.2-8.8V93h-10.3L130.4,114.8 L130.4,114.8z M210.4,99.7c-1.3-2.2-3-4-5.2-5.4c-2.2-1.4-4.7-2.1-7.5-2.1c-2.9,0-5.5,0.6-7.8,1.9c-1.2,0.7-2.3,1.5-3.3,2.5V93 h-10.3v38.1h10.3v-21.8c0-1.5,0.3-2.9,1-4c0.7-1.2,1.6-2,2.7-2.7s2.5-0.9,3.9-0.9c2.3,0,4.1,0.7,5.5,2.1c1.4,1.4,2.1,3.3,2.1,5.5 v31.9h10.3v-34.3C212.3,104.4,211.7,102,210.4,99.7z M170.3,93.1c-1.5-0.6-3.1-0.9-5-0.9c-4.3,0-7.5,1.4-9.8,4.1 c0,0-0.1,0.1-0.1,0.1V93h-10.3v38.1h10.3V110c0-2.8,0.7-4.9,2.1-6.3c1.4-1.4,3.2-2.1,5.4-2.1c1.1,0,2,0.2,2.8,0.5 c0.8,0.3,1.5,0.8,2.1,1.4l6.5-7.4C173.1,94.7,171.8,93.7,170.3,93.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068663708649145062080000010308317334248296356_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.9385,
    y1: 218.2215,
    x2: 281.8444,
    y2: 218.2215,
    gradientTransform: "matrix(1 0 0 -1 0 376.6277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffffff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000068663708649145062080000010308317334248296356_)"
    },
    d: "M80.9,184.8h10.4v-53.5l-10.4,10.5V184.8 z M134.4,160.5c2.6-1.3,4.7-3.1,6.1-5.4c1.4-2.3,2.2-5,2.2-8.2c0-3.1-0.7-5.7-2.2-8.1c-1.4-2.3-3.5-4.2-6.1-5.5 c-2.6-1.3-5.6-2-9.1-2h-10.6H112h-7.6v53.5h10.4v-22.4h1.8l17.1,22.4h12.6l-17.9-22.6C130.5,162,132.6,161.4,134.4,160.5z  M114.7,154.4v-14.6h9.7c2.5,0,4.5,0.7,5.9,2.1c1.4,1.4,2.1,3.1,2.1,5.2c0,2.3-0.7,4.1-2.1,5.4c-1.4,1.3-3.4,1.9-5.9,1.9 L114.7,154.4L114.7,154.4z M255,175.7v-13.8h24.2v-8.8H255v-12.6h26.5v-9.1H255h-2.7h-7.6v53.5h7.6h2.7h26.9v-9.1L255,175.7 L255,175.7z M184.3,174.8c-2.1,0.9-4.6,1.3-7.5,1.3c-2.4,0-4.6-0.4-6.6-1.3c-2-0.8-3.7-2-5.2-3.6c-1.5-1.6-2.6-3.4-3.4-5.5 c-0.8-2.1-1.2-4.5-1.2-7.1c0-2.6,0.4-4.9,1.2-7.1c0.8-2.2,1.9-4,3.4-5.6c1.5-1.6,3.2-2.7,5.2-3.6c2-0.8,4.2-1.2,6.6-1.2 c2.8,0,5.2,0.5,7.3,1.3c2.1,0.9,3.8,2.1,5.3,3.7l6.8-6.8c-2.4-2.4-5.2-4.2-8.4-5.6c-3.2-1.4-6.8-2-11-2c-3.9,0-7.4,0.7-10.6,2.1 c-3.2,1.4-6.1,3.3-8.5,5.7c-2.4,2.4-4.3,5.3-5.6,8.5c-1.3,3.3-2,6.8-2,10.5c0,3.7,0.7,7.3,2,10.5s3.2,6.1,5.6,8.6 c2.4,2.4,5.3,4.4,8.6,5.7c3.3,1.4,6.8,2,10.6,2c4.3,0,8-0.7,11.2-2c3.2-1.3,6-3.2,8.5-5.6l-6.8-6.8 C188.1,172.7,186.4,173.9,184.3,174.8z M212.3,131.3l-10.4,9.9v43.6h7.6h2.7h24.5v-9.2h-24.5L212.3,131.3L212.3,131.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059267661461832475240000005826938435476818324_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.2425,
    y1: 294.2922,
    x2: 279.5016,
    y2: 294.2922,
    gradientTransform: "matrix(1 0 0 -1 0 376.6277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffffff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059267661461832475240000005826938435476818324_)"
    },
    d: "M240.3,96V106h25.1V96 c0-7.8,6.3-14.2,14.1-14.4c-4.5-30.6-48.8-30.6-53.3,0C234,81.8,240.3,88.1,240.3,96z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122716884371290098520000013533243161153310629_",
    gradientUnits: "userSpaceOnUse",
    x1: 215.8649,
    y1: 268.1746,
    x2: 289.8792,
    y2: 268.1746,
    gradientTransform: "matrix(1 0 0 -1 0 376.6277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffffff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122716884371290098520000013533243161153310629_)"
    },
    d: "M279.8,85.9c-5.6,0-10.1,4.5-10.1,10.1 v14.4H236V96c0-5.6-4.5-10.1-10.1-10.1s-10.1,4.5-10.1,10.1c0,4.9,3.6,9.1,8.3,9.9v21h6v4.1h6.6l2.2-4.1h28l2.2,4.1h6.6v-4.1h6v-21 c4.7-0.8,8.3-4.9,8.3-9.9C289.9,90.4,285.4,85.9,279.8,85.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010280005029237340540000005416019558257534383_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.8422,
    y1: 244.8664,
    x2: 142.5584,
    y2: 348.5826,
    gradientTransform: "matrix(1 0 0 -1 0 376.6277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffffff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010280005029237340540000005416019558257534383_)"
    },
    d: "M16.4,132.6c0-1.1-0.1-2.3-0.1-3.3 c0-27.2,9.8-53.4,27.6-73.8C61.7,35.2,86,22,112.4,18.1c1.3-0.2,2.5-0.4,3.6-0.5c4.6-0.6,9.2-0.9,13.8-0.9c4.8,0,9.6,0.3,14.4,0.9 l4.3,0.5L155.3,0l34.6,52.2l-60.4,16.6l7.9-21.2c-1-0.1-1.9-0.2-2.8-0.2h-4.9c-3.3,0-6.7,0.2-10,0.6c-17.1,2.1-33.5,9.8-46.1,21.7 c-9.7,9.1-16.9,20-21.2,32.5l-1.6,4.7l-0.1-0.1c-1.4,4.9-2.4,10-2.9,15.1l-0.6,6.8l-11.8-15.3L16.7,141L16.4,132.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010311929935653015240000006519198450344949692_",
    gradientUnits: "userSpaceOnUse",
    x1: 884.5342,
    y1: -778.749,
    x2: 850.1522,
    y2: -644.6464,
    gradientTransform: "matrix(0.9687 0.2484 0.2484 -0.9687 -567.2512 -731.5559)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02963436,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2603,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3831,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5119,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6497,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8025,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffffff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M130.3,242.5c-19.5,0-38.8-5-55.7-14.6 c-21.6-12.2-38.2-30.7-48.1-53.5l0-0.1c-0.4-1-3.4-9-5.5-15.2l-1.3-3.8L0,156l35-51.9l38.4,49.5l-22.1,0.7l2.9,7.2 c0.1,0.3,0.2,0.5,0.3,0.8l0,0.1c7.2,16.6,19.3,30.1,35.1,39c12.3,6.9,26.3,10.6,40.5,10.6c3.3,0,6.6-0.2,9.8-0.6l0.1,0 c7.7-1,15.2-3,22.4-6.1c0.8-0.3,1.5-0.7,2.3-1l1.5-0.7l26,20.2l-3.3,2c-4.8,3-9.5,5.4-14.4,7.6c-9.9,4.3-20.2,7.1-30.8,8.4l-0.1,0 C139.3,242.3,134.8,242.5,130.3,242.5z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.9311adc6360fe8f53945519f91798b91.svg";
export { ForwardRef as ReactComponent };